import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';
import { userHandle } from '@/components/user-badge/user-badge.css';

export const bannerTopContainer = style([
  {
    borderRadius: space.s16,
    outline: `1px solid ${themeVars.container.border.default}`,
    outlineOffset: '-1px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: themeVars.container.primary.background.idle,
  },
  responsiveStyle({
    tablet: {
      padding: space.s32,
    },
  }),
]);

export const bannerContainer = style([
  {
    display: 'flex',
    flexDirection: 'column',
  },
  responsiveStyle({
    tablet: {
      gap: space.s24,
      flexDirection: 'row',
    },
  }),
]);

export const bannerContent = style([
  {
    padding: `${space.s12}px ${space.s16}px ${space.s16}px ${space.s16}px`,
    display: 'flex',
    flexDirection: 'column',
    gap: space.s24,
    flexGrow: 1,
    justifyContent: 'space-between',
  },
  responsiveStyle({
    tablet: {
      padding: 0,
    },
  }),
]);

export const bannerImgContainer = style([
  {
    backgroundColor: themeVars.container.secondary.background.idle,
    aspectRatio: '21 / 9',
    borderRadius: `${space.s16}px ${space.s16}px 0 0`,
    overflow: 'hidden',
    flexShrink: 0,
  },
  responsiveStyle({
    tablet: {
      aspectRatio: '3 / 2',
      borderRadius: borderRadius.r12,
      width: '47%',
    },
  }),
]);
export const bannerImg = style({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

export const bannerInfo = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  gap: space.s8,
});

export const bannerTitle = style([
  { marginTop: space.s8 },
  responsiveStyle({
    mobile: {
      ...typography.titleMd,
    },
    tablet: {
      ...typography.headlineLg,
    },
  }),
]);

export const bannerBody = style([
  responsiveStyle({
    mobile: {
      ...typography.labelMd,
    },
    tablet: {
      ...typography.titleMd,
    },
  }),
]);

export const bannerManagedBy = style([
  userHandle,
  {
    maxWidth: '100%',
  },
]);

export const bannerManagedByLink = style({
  ':hover': {
    textDecoration: 'underline',
  },
});

export const bannerLabels = style([
  {
    display: 'flex',
    gap: space.s12,
  },
]);

export const bannerFooter = style([
  {
    display: 'grid',
    gap: space.s8,
    gridAutoFlow: 'column',
    gridAutoColumns: '1fr',
    minHeight: 33,
  },
  responsiveStyle({
    tablet: {
      gridAutoColumns: 'max-content',
      justifyContent: 'flex-end',
    },
  }),
]);

export const bannerFooterWithPrize = style([
  responsiveStyle({
    mobile: {
      gridAutoFlow: 'row',
    },
    tablet: {
      gridAutoColumns: 'max-content',
    },
    laptop: {},
    desktop: {
      gridAutoFlow: 'column',
      justifyContent: 'space-between',
    },
  }),
]);

export const bannerMoneyBadgeContainer = style([
  responsiveStyle({
    tablet: {
      marginLeft: 'auto',
    },
    laptop: {},
    desktop: {
      marginLeft: 'unset',
    },
  }),
]);

export const bannerCardMoneyLabel = style({
  ...typography.labelMd,
  gap: space.s4,
  color: themeVars.container.foreground.primary,
  ':hover': {
    backgroundColor: themeVars.color.bgFill.interactive.tertiary.default,
  },
  boxShadow: `0 0 0 1px ${themeVars.color.border.tertiary}`,
  cursor: 'default',
  ...responsiveStyle({
    mobile: {
      width: 'auto',
    },
    tablet: {
      width: 'fit-content',
    },
  }),
});

export const bannerTournamentMedals = style({
  marginTop: space.s24,
  ...responsiveStyle({
    mobile: {
      marginTop: space.s16,
      paddingLeft: space.s16,
      paddingRight: space.s16,
    },
    tablet: {
      padding: 0,
    },
  }),
});

export const bannerFooterContainer = style({
  display: 'flex',
  justifyContent: 'center',

  ...responsiveStyle({
    mobile: {
      paddingBottom: space.s16,
    },
    tablet: {
      paddingBottom: 0,
    },
  }),
});

export const bannerShowMoreButton = style({
  ...responsiveStyle({
    mobile: {
      ...typography['labelMd'],
    },
    tablet: {
      marginTop: space.s24,
    },
    desktop: {
      ...typography['bodyMd'],
    },
  }),
});
